import React from "react";
import { StyleSheet, View } from "react-native";
import "../../../App.scss";
import IntroPanel from "../../../Components/Layout/Default/intro-panel";

const Index = (props) => {
  return (
    <View style={styles.content}>
      <IntroPanel
        buttonColor="esg"
        header={props.moduleObject.name}
        buttonText="Get started"
        onButtonPress={props.pageOne}
      >
        <React.Fragment>
          Investors have power you know!
          {"\n"}
          {"\n"}
          The following screens will tell us whether you'd like your investment
          to support your preferences around issues such as climate change and
          equality.
        </React.Fragment>
      </IntroPanel>
    </View>
  );
};
export default Index;
const styles = StyleSheet.create({
  content: {
    height: "100vh",
    width: "100vw",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
});
